import * as React from 'react'

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

import { Helmet } from 'react-helmet';

import LogoIcon from '../../../../../assets/images/Logos/BHBUSMidia.webp';
import { AddressDiv, ContactDiv, ContentDiv, CopyRight, IconArea, IconsDiv, LeftSide, Logo, PrincipalDiv } from './styles';
import { useCallback } from 'react';

interface IFooterProps {
  lp?: boolean;
}


const FooterLP: React.FC<IFooterProps> = ({ lp }) => {

  const handleLinkedinClick = useCallback(() => {
    window.open('https://www.linkedin.com/company/bhbusmidia/?originalSubdomain=br', '_blank');
  }, []);

  const handleInstagramClick = useCallback(() => {
    window.open('https://www.instagram.com/bhbusmidia/', '_blank');
  }, []);

  return (
    <PrincipalDiv>
      <Helmet>
        <link rel="preload" href={LogoIcon} as="image" type="image/webp" />
      </Helmet>
        <ContentDiv>
          <LeftSide>
            <Logo src={LogoIcon} alt="BHBUS Mídia Logo" />
            <strong>BHBUS Mídia</strong>
          </LeftSide>
          <ContactDiv>
            <IconsDiv>
              <IconArea>
                <InstagramIcon className="icons" onClick={handleInstagramClick} />
              </IconArea>
              <IconArea>
                <LinkedInIcon className="icons" onClick={handleLinkedinClick} />
              </IconArea>
              
            </IconsDiv>
            <p>© 2025 BHBUS Mídia</p>
            <p>Todos os direitos reservados.</p>
          </ContactDiv>
        </ContentDiv>
    </PrincipalDiv>
  );
};

export { FooterLP };